<template>
	<div class="curriculum_page">
		<div class="curriculum_main">
			<div class="curriculumPage">
				<p class="page_title">Chartered Financial Analyst</p>
				<div class="nav_content">
					<p class="nav_title">课程目录</p>
					<ul>
						<li v-for="(item,index) in weekList" :key="index" @click="changeNav('community_one')">
							<p :class="{nav_content_item_active:item_show=='index'}">{{item}}</p>
						</li>
						<li @click="test_result">
							<p>结果测试</p>
						</li>
						<li @click="certificate_preview">
							<p>证书预览</p>
						</li>
					</ul>
				</div>
				<div class="curriculum_components">
					<component :is="item_show"></component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import week from '../../components/curriculum/Week.vue'
	export default {
		name: 'Curriculum',
		components: {
			week
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		data() {
			return {
				item_show: 'week', //默认周课程
				weekList:["第一周","第二周","第三周","第四周","第五周"]
			}
		},
		methods: {
			test_result:function(){
				alert("测试结果")
			},
			certificate_preview:function(){
				alert("证书预览")
			}
		}
	}
</script>

<style scoped="scoped">
	.curriculum_page {
		width: 100%;
		background-image: url("https://static.wixstatic.com/media/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.webp");
		background-size: cover;
		/* background-position: center center; */
		background-repeat: no-repeat;
	}

	.curriculum_main {
		background-color: rgb(65, 65, 65, 0.5);
		width: 100%;
		height: 100%;
		min-height: 600px;
		padding-bottom: 50px;
	}

	.curriculumPage {
		width: 1024px;
		margin: 0 auto;
		padding-top:140px;
	}

	.curriculumPage .page_title {
		height: 30px;
		line-height: 30px;
		font-size: 30px;
		color: #FAFAFA;
	}

	.nav_content {
		width: 180px;
		min-height: 200px;
		margin: 0 auto;
		position: absolute;
		margin-top: 40px;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 20px;
		padding: 30px 20px 10px 20px;
	}

	.nav_content .nav_title {
		height: 15px;
		line-height: 15px;
		font-size: 15px;
		color: #E8E6E6;
		padding-bottom: 14px;
		text-align: center;
		border-bottom: 1px #414141 solid;
	}
	.nav_content ul{
		overflow: hidden;
		position: relative;
		zoom: 1;
		margin-top:10px;
	}
	.nav_content ul li{
		width: 100%;
		height: 26px;
		line-height: 26px;
		font-size: 14px;
		color:#C7C7C7;
		text-align: center;
	}
	.curriculum_components{
		width: 680px;
		min-height: 200px;
		position: relative;
		margin-top: 40px;
		float: right;
		margin-left: 100px;
		right: 50px;
		border:1px #f00 solid;
	}
</style>



// WEBPACK FOOTER //
// src/views/curriculum/curriculum.vue